/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent } from '@material-ui/core';
import {
  Div, Figure, weight, colors,
} from 'globalStyle';
import arrowLeft from 'assets/icons/arrowLeftHeader.svg';
import closeIcon from 'assets/icons/closeIcon.svg';
import { TextLight } from 'components/Texts';
import { formatNumber } from 'util/formatNumber';
import styled from 'styled-components';
import { useMediaQuery } from 'hooks';
import { Hollow } from 'components/Buttons';
import { downloadExcel } from 'util/downloadExcel';
import { downloadPaymentPlanSimulator } from 'services/other/bankVision';
import { capitalizeFirstLetterString } from 'util/capitalizeFirstLetter';
import { payFrequency } from 'types';
import TablePaymentDetails from './TablePaymentDetails';
import { getDownloadPlanBody } from './downloadPaymentsPlanBody';

export default function PaymentDetails({
  handleClose,
  simulatorData,
  investmentInfo,
  handleBack,
  project,
  amount,
}) {
  const [payments, setPayments] = useState([]);
  const [pageNumber, setPageNumber] = useState([]);
  const [currentlyPage, setCurrentlyPage] = useState(0);
  const [loadingDownloadPayment, setLoadingDownloadPayment] = useState(false);
  const paymentsPerPage = 7;
  const isDesktop = useMediaQuery(1023);

  useEffect(() => {
    const pages = [];
    const lengthPayments = simulatorData?.length;
    if (lengthPayments > 0 && lengthPayments < paymentsPerPage) {
      pages.push(simulatorData);
      setPayments(pages);
      setPageNumber([0]);
    } else if (lengthPayments > 0) {
      const pageCount = Math.ceil(lengthPayments / paymentsPerPage);
      const contentPages = Array.from({ length: pageCount }, (_, index) => simulatorData.slice(
        index * paymentsPerPage,
        (index + 1) * paymentsPerPage,
      ));

      setPayments(contentPages);

      for (let i = 0; i < pageCount; i += 1) {
        pages.push(i);
      }
      setPageNumber(pages);
    }
  }, [simulatorData]);
  const stopLoadingDownloadPlan = () => {
    setLoadingDownloadPayment(false);
  };

  const downloadPlan = () => {
    const infoDownload = getDownloadPlanBody(
      simulatorData,
      project?.projectId,
      amount,
    );
    setLoadingDownloadPayment(true);
    downloadPaymentPlanSimulator(infoDownload)
      .then(({ data }) => {
        downloadExcel(
          data,
          stopLoadingDownloadPlan,
          `proyectado de pagos proyecto ${project?.projectName}`,
        );
      })
      .catch(() => {
        stopLoadingDownloadPlan();
      });
  };

  const tableInfo = isDesktop ? payments[currentlyPage] : simulatorData;

  const Header = () => {
    if (isDesktop) {
      return (
        <Div
          p="20px 10px"
          margin="30px 0"
          style={{
            border: `2px solid ${colors.primary}`,
            borderRadius: '20px',
          }}
          isFlex
          justify="space-between"
          width="100%"
        >
          <TextLight
            size={13}
            color={colors.primary}
            weight={weight.BOLD}
            align="start"
          >
            Inversión inicial:
            <span
              style={{
                color: colors.GRAY_1,
                marginLeft: '5px',
                fontWeight: weight.MEDIUM,
              }}
            >
              {formatNumber(amount)}
            </span>
          </TextLight>
          <TextLight size={13} color={colors.primary} weight={weight.BOLD}>
            Ganancia de intereses:
            <span
              style={{
                color: colors.GRAY_1,
                marginLeft: '5px',
                fontWeight: weight.MEDIUM,
              }}
            >
              {formatNumber(investmentInfo?.amountInteres)}
            </span>
          </TextLight>
          <TextLight size={13} color={colors.primary} weight={weight.BOLD}>
            Recibes en total:
            <span
              style={{
                color: colors.GRAY_1,
                marginLeft: '5px',
                fontWeight: weight.MEDIUM,
              }}
            >
              {formatNumber(investmentInfo?.amountTotal)}
            </span>
          </TextLight>
        </Div>
      );
    }
    return (
      <Div
        p="20px 10px"
        margin="20px 0 0"
        style={{
          border: `2px solid ${colors.primary}`,
          borderRadius: '10px',
          gap: '20px',
        }}
        width="100%"
        height="55px"
        isFlex
        justify="flex-start"
      >
        <TextLight
          size={13}
          color={colors.primary}
          weight={weight.BOLD}
          width="auto"
        >
          Período de pago:
        </TextLight>
        {project?.frequencyInterest === project?.frequency ? (
          <Div style={{ textAlign: 'start' }}>
            <TextLight size={13} weight={weight.MEDIUM}>
              {capitalizeFirstLetterString(payFrequency[project?.frequency])}
            </TextLight>
            <TextLight size={13} weight={weight.MEDIUM}>
              Interés y capital
            </TextLight>
          </Div>
        ) : (
          <Div style={{ textAlign: 'start' }}>
            <TextLight size={13} weight={weight.BOLD}>
              Interés:
              <span
                style={{
                  color: colors.GRAY_1,
                  marginLeft: '5px',
                  fontWeight: weight.MEDIUM,
                }}
              >
                {capitalizeFirstLetterString(
                  payFrequency[
                    project?.frequencyInterest || project?.frequency
                  ],
                )}
              </span>
            </TextLight>
            <TextLight size={13} weight={weight.BOLD}>
              Capital:
              <span
                style={{
                  color: colors.GRAY_1,
                  marginLeft: '5px',
                  fontWeight: weight.MEDIUM,
                }}
              >
                {capitalizeFirstLetterString(payFrequency[project?.frequency])}
              </span>
            </TextLight>
          </Div>
        )}
      </Div>
    );
  };

  return (
    <Dialog
      open
      PaperProps={{
        style: { borderRadius: '30px', padding: '30px' },
      }}
      maxWidth="md"
    >
      <Div isFlex justify="space-between" align="flex-start">
        <Figure
          style={{
            width: '25px',
            height: '25px',
            cursor: 'pointer',
          }}
          onClick={() => {
            handleBack();
          }}
        >
          <img
            src={arrowLeft}
            alt="atrás"
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        </Figure>
        <TextLight
          color={isDesktop && colors.primary}
          size={20}
          weight={weight.BOLD}
          width="auto"
        >
          Detalle de pagos
        </TextLight>
        <Figure
          style={{
            width: '25px',
            height: '18px',
            cursor: 'pointer',
          }}
          onClick={() => {
            handleClose();
          }}
        >
          <img
            src={closeIcon}
            alt="cerrar"
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        </Figure>
      </Div>
      <DialogContent
        style={{
          'max-width': '800px',
          padding: '0',
          width: isDesktop ? '800px' : '100%',
          overflowX: 'hidden',
        }}
        align="center"
      >
        <Header />
        <TablePaymentDetails
          fullWidth
          data={tableInfo?.map((data, index) => ({
            index,
            rows: {
              Cuota: { v: data.numeroCuota || data.cuota },
              'Abono a capital': {
                v: formatNumber(data.capital || data.paymentToCapital || 0),
              },
              'Abono interés': {
                v: formatNumber(data.interescuota || data.interest || 0),
              },
              'Pago total': {
                v: formatNumber(
                  data.capital + data.interescuota - data.reteFuente
                    || data.paymentToCapital + data.interest - data.reteFuente
                    || 0,
                ),
              },
            },
          }))}
        >
          <td colSpan="5">
            <Div
              isFlex
              justify="flex-end"
              height="40px"
              style={{
                columnGap: '10px',
                borderRadius: '0 0 15px 15px',
                backgroundColor: colors.background.GRAY_3,
              }}
              padding="0 10px 0 0"
            >
              {pageNumber.map((page) => (
                <PageNumber
                  onClick={() => {
                    setCurrentlyPage(page);
                  }}
                  active={currentlyPage === page}
                >
                  <TextLight
                    isCenter
                    color={currentlyPage === page && colors.WHITE}
                    weight={
                      currentlyPage === page ? weight.BOLD : weight.SEMI_BOLD
                    }
                    size={10}
                  >
                    {page + 1}
                  </TextLight>
                </PageNumber>
              ))}

              <TextLight
                size={11}
                width="auto"
                weight={weight.SEMI_BOLD}
                color={
                  currentlyPage + 1 >= payments?.length
                    ? colors.GRAY_3
                    : colors.GRAY_1
                }
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => {
                  if (currentlyPage + 1 < payments?.length) {
                    setCurrentlyPage(currentlyPage + 1);
                  }
                }}
              >
                Siguiente
              </TextLight>
            </Div>
          </td>
        </TablePaymentDetails>

        <Hollow
          isSubmit
          onColorType="primary"
          color={colors.BLACK}
          padding="0 12px"
          isLoading={loadingDownloadPayment}
          onClick={() => {
            downloadPlan();
          }}
          style={{
            width: isDesktop ? '330px' : '100%',
            height: '45px',
            marginTop: '30px',
          }}
        >
          Descargar detalle de pagos
        </Hollow>
      </DialogContent>
    </Dialog>
  );
}

const PageNumber = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background: ${(props) => props.active && colors.secondary};
  display: flex;
  align-item: center;
  cursor: pointer;
`;
